<!-- 此component用來跳出個人 Comment -->
<template>
  <el-dialog v-if="status === 0" title="撰寫評價" class="comment-title" :visible="dialogFormVisible" :show-close="false">
    <el-form style="margin-top: -20px;">
      <span class="comment-hint">歡迎您給予鼓勵、提出建議，您的心得與想法都將是大家的最佳參考</span>
      <el-form-item>
        <span class="comment-userinfo">
          <div v-if="!check">
            <img src="../../assets/icon/ic_user_2.png"/> {{name}}
          </div>
          <div v-else>
            <img src="../../assets/icon/ic_user_2.png"/> 匿名 
          </div> 
        </span>
        <StarRating 
          class="comment-star" 
          :rating="rating" 
          :show-rating="true" 
          :max-rating="5" 
          :star-size="28" 
          :read-only="false" 
          :increment="1"
          @rating-selected ="setRating">
				</StarRating>
        <span class="comment-date"> {{date}} </span>
      </el-form-item>
      <el-form-item>
        <textarea 
          class="edit-experince" 
          :maxlength="500" 
          cols="30"
          rows="8" 
          v-model="$store.state.editResource.myComment.content" 
          placeholder="提供對這個科普主題的心得...">
        </textarea>
      </el-form-item>
      <el-checkbox v-model="check" @change="handleCheckedChange" class="anonymous-checkbox" border>匿名評價</el-checkbox>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="$emit('close')">取消</el-button>
      <el-button type="primary" @click="$emit('release')">發佈</el-button>
    </div>
  </el-dialog>
  <el-dialog v-else-if="status === 1" title="修改評價" class="comment-title" :visible="dialogFormVisible" :show-close="false">
    <el-form style="margin-top: -20px;">
      <span class="comment-hint">歡迎您給予鼓勵、提出建議，您的心得與想法都將是大家的最佳參考</span>
      <el-form-item>
        <span class="comment-userinfo">
          <div v-if="!check">
            <img src="../../assets/icon/ic_user_2.png"/> {{name}}
          </div>
          <div v-else>
            <img src="../../assets/icon/ic_user_2.png"/> 匿名 
          </div> 
        </span>
        <StarRating 
          class="comment-star" 
          :rating="rating" 
          :show-rating="true" 
          :max-rating="5" 
          :star-size="28" 
          :read-only="false" 
          :increment="1"
          @rating-selected ="setRating">
				</StarRating>
        <span class="comment-date"> {{date}} </span>
      </el-form-item>
      <el-form-item>
        <textarea 
          class="edit-experince" 
          :maxlength="500" 
          cols="30"
          rows="10" 
          v-model="$store.state.editResource.myComment.content" 
          placeholder="提供對這個科普主題的心得...">
        </textarea>
      </el-form-item>
      <el-checkbox v-model="check" @change="handleCheckedChange" class="anonymous-checkbox" border>匿名評價</el-checkbox>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="$emit('close')">取消</el-button>
      <el-button type="primary" @click="$emit('change')">修改</el-button>
    </div>
  </el-dialog>
  <el-dialog v-else title="回覆評價" class="comment-title" :visible="dialogFormVisible" :show-close="false">
    <el-form>
      <el-form-item>
        <span class="comment-userinfo">
          <img src="../../assets/icon/ic_user_2.png"/> {{name}}
        </span>
        <StarRating 
          class="comment-star" 
          :rating="rating" 
          :show-rating="false" 
          :max-rating="5" 
          :star-size="20" 
          :read-only="true" 
          :increment="1"
          @rating-selected ="setRating">
				</StarRating>
        <span class="comment-date" style="margin-top: 3px" > {{date}} </span>
      </el-form-item>
      <el-form-item>
        <textarea 
          v-show="$store.state.editResource.myComment.content !== ''"
          class="edit-experince"
          style="background-color: #FAFCFF" 
          :maxlength="500" 
          cols="30"
          rows="5" 
          v-model="$store.state.editResource.myComment.content"
          disabled>
        </textarea>
        <textarea 
          class="edit-experince" 
          :maxlength="500" 
          cols="30"
          rows="10" 
          v-model="$store.state.editResource.reply" 
          placeholder="在此輸入您對該則評論的回覆...">
        </textarea>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="$emit('close')">取消</el-button>
      <el-button type="primary" @click="$emit('reply')">回覆</el-button>
    </div> 
  </el-dialog>
</template>

<script>
  export default {
    props: {
      resourceId: Number,
      name: String,
      content: String,
      rating: Number,
      date: String,
      reply: String,
      status: 0,
      id: Number,
      anonymous: Number
    },
    data() {
      return {
        dialogFormVisible: true,
        check: false
      };
    },
    created() {
      this.$store.state.editResource.myComment.id = this.id;  
      this.$store.state.editResource.myComment.content = this.content;  
      this.$store.state.editResource.reply = this.reply;
      this.$store.state.editResource.myComment.rating = this.rating;
      this.$store.state.editResource.myComment.anonymous = this.anonymous; 
      this.check = true ? this.anonymous === 1 : this.anonymous === 0;
    },
    methods: {
      setRating: function(val) {
        this.$store.state.editResource.myComment.rating = val;
      },
      handleCheckedChange: function(event) {
        this.check = event.target.checked;
        if(this.check) {
          this.$store.state.editResource.myComment.anonymous = 1;
        } else {
          this.$store.state.editResource.myComment.anonymous = 0;
        }
      }
    }
  };
</script>
<style scoped lang="scss">
$font-color: #515151;
$font-color2: #1D2327;
$white-color: #ffffff;
.comment-title {
  color: $font-color;
  line-height: 24px;
  font-size: 18px;
}
.comment-userinfo {
  font-size: 14px;
  color: #1D2327;
  display: block;
  float: left;
  width: 100%;
  img {
    width: 22px;
    height: 22px;
    border-radius: 20px;
    float: left;
    margin-right:9px;
    margin-top: 7px;
  }
}
.edit-experince {
  background-color: $white-color;
  border-radius: 2px;
  border: 1px solid #C7CAD1;
  height: auto;
  width: 100%;
  font-size: 14px;
  padding-left: 14.5px;
  padding-top: 14.5px;
}
.comment-star {
  margin-top: 10px;
  font-size: 16px !important; 
  line-height: 10px;
  color: #515151;
  float: left;
  display: block;
}
.comment-hint {
  color: $font-color;
  line-height: 48px;
  font-size: 14px;
  margin-top: -7px;
}
.comment-date {
  margin-left: 30px;
  margin-top: 8px;
  font-size: 14px; 
  float: left;
  color: #515151;  
}
.anonymous-checkbox {
  top: -20px;
  font-size: 16px;
  color: #515151;
}
</style>



// WEBPACK FOOTER //
// Comment.vue?9cd9a174